module.exports = __webpack_public_path__ + "5363f71b30bf8ff4c6933cc1b4c38bc6.svg";